<template>
  <a-select :value="value" @change="changeHandler">
    <a-select-option
      v-for="(option, index) in options"
      :key="index"
      :value="option.value"
    >{{option.name}}</a-select-option>
  </a-select>
</template>

<script>
  import { Select } from 'ant-design-vue'
  const { Option } = Select
  export default {
    name: "suggestion-cate-selector",
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      value: {}
    },
    data() {
      return {
        options: [
          {
            name: '系统操作方面',
            value: '0'
          },
          {
            name: '数据正确性方面',
            value: '1'
          },
          {
            name: '新需求方面',
            value: '2'
          },
          {
            name: '改善建议',
            value: '3'
          },
          {
            name: '其他',
            value: '4'
          },
        ]
      }
    },
    methods: {
      changeHandler (value) {
        this.$emit('change', value)
      },
      getMapperName (v) {
        return this.options.find(item => item.value = v).name
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
